import React from 'react'
import { history } from '../store'
import '../styles/QRsAdminView.css'

class MiniList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filterOpen: true,
      filters: {
        serial: '',
        customer: '',
      },
    };
    this.toggleFilter = this.toggleFilter.bind(this)
  }

  goTo(Serial, e) {
    history.push(`/minis/${Serial}`)
  }

  toggleFilter() {
    this.setState(prev => ({ filterOpen: !prev.filterOpen }))
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  render() {
    const { filters, filterOpen } = this.state;
    const { minis } = this.props;

    if (!minis) {
      return (<div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    const filteredMinis = minis.filter(mini => {
      const { serial, customer } = filters;
      if (serial && !mini.Serial.toLowerCase().includes(serial.toLowerCase())) return false;
      if (customer && (!mini.Comments || !mini.Comments.toLowerCase().includes(customer.toLowerCase()))) return false;
      return true;
    });

    return (
      <div>
        {/* Collapsible Filter Panel */}
        <div className="qrs-admin-filter-card">
          <div className="qrs-admin-filter-header" onClick={this.toggleFilter}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
          </div>
          {filterOpen && (
            <div className="qrs-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label>Identificador</label>
                  <input
                    type="text"
                    placeholder="Buscar por serial..."
                    value={filters.serial}
                    onChange={e => this.handleFilterChange('serial', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label>Comentarios</label>
                  <input
                    type="text"
                    placeholder="Buscar por comentarios..."
                    value={filters.customer}
                    onChange={e => this.handleFilterChange('customer', e.target.value)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Column Headers */}
        <div className="qrs-admin-list-header">
          <div className="qrs-header-col col-id">Identificador</div>
          <div className="qrs-header-col col-customer">Comentarios</div>
          <div className="qrs-header-col col-payments">Fecha de fabricación</div>
        </div>

        {/* Cards */}
        <div className="qrs-admin-list">
          {filteredMinis.length > 0 ? filteredMinis.map(mini => (
            <div key={mini.Serial} className="qrs-admin-card" onClick={e => this.goTo(mini.Serial, e)}>
              <div className="qrs-admin-row">
                <div className="qrs-admin-status-bar ENABLED"></div>
                <div className="qrs-admin-content">
                  <div className="qrs-admin-machine-id">
                    <div className="qrs-admin-code">{mini.Serial}</div>
                  </div>
                  <div className="qrs-admin-machine-customer">
                    <div className="qrs-admin-customer-name">{mini.Comments || '—'}</div>
                  </div>
                  <div className="qrs-admin-machine-payments">
                    <div className="qrs-admin-sub">
                      {(new Date(mini.Build_date)).toLocaleString('es-ES', { timeZone: 'Europe/Madrid', hour12: false })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )) : (
            <div className="qrs-admin-empty">
              <i className="fas fa-tablet-alt"></i>
              <p>No se encontraron minis</p>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default MiniList

